import { ajax } from './ajax';
import { monitor } from './monitor';
import { ExceptionCategory } from './enum';

class Request {
  getWithdrawPage(callback: (res: any) => void, data: IWithdrawPageReq): void {
    const url = `/balance/withdrawStart`;
    ajax({
      data,
      url,
    })
      .then((res: any) => {
        if (res.status === 'success') {
          callback(res.data);
        }
      })
      .catch(() => {
        // empty
      });
  }

  // 余额提现下单
  getWithdrawNo(data: IWithdrawOrderReq): Promise<IWithdrawOrderRes> {
    const url = '/balanceproduct/withdraw/order';
    return ajax({
      data,
      url,
    });
  }

  submitWithdraw(data: any, callback: (res: any) => void, fail: (err: any) => void): void {
    const url = '/balance/balanceWithdrawConfirm';
    ajax({
      data,
      url,
    })
      .then((res: any) => {
        monitor.captureMessage('提现确认正常返回', { tags: res });
        if (res.status === 'success') {
          callback(res.data);
        }
      })
      .catch((err) => {
        monitor.captureMessage('提现确认网络异常', { tags: err });
        fail(err);
      });
  }

  getRechargePage(callback: (res: any) => void): void {
    const url = `/balance/rechargeStart`;
    ajax({
      url,
    })
      .then((res: any) => {
        if (res.status === 'success') {
          callback(res.data);
        }
      })
      .catch(() => {
        // empty
      });
  }

  submitRecharge(data: any, successCallback: (res: any) => void, failCallback: () => void): void {
    const url = `/balance/rechargeConfirm`;
    ajax({
      data,
      url,
    })
      .then((res: any) => {
        if (res.status === 'success') {
          successCallback(res.data);
        }
      })
      .catch(() => {
        failCallback();
      });
  }

  cashDeskRecharge(data: any, successCallback: (res: any) => void, failCallback: () => void): void {
    const url = `/qdbdisplay/cashdesk`;
    ajax({
      data,
      url,
    })
      .then((res: any) => {
        if (res.status === 'success') {
          successCallback(res.data);
        }
      })
      .catch(() => {
        failCallback();
      });
  }

  getMainPage(callback: (res: any) => void): void {
    const url = `/balance/mainPage`;
    ajax({
      data: {},
      url,
    })
      .then((res: any) => {
        if (res.status === 'success') {
          callback(res.data);
        }
      })
      .catch((error) => {
        callback({});
        monitor.captureAjaxErrorMessage(`${ExceptionCategory.Exception}余额首页接口加载失败`, { error });
      });
  }

  fetchGuideInfo() {
    return ajax({
      url: '/balance/guideInfo',
      data: {},
    });
  }

  riskRequest(url: string, data: Record<string, any>) {
    return ajax({
      url,
      data,
    });
  }

  // 上报弹窗黑名单 /api/mpm/payment-account/report-black-type
  fetchReportBlackType(data: any, successCallback?: (res: any) => void, failCallback?: () => void) {
    const url = `/api/mpm/payment-account/report-black-type`;
    ajax({
      data,
      url,
    }).catch((error) => {
      monitor.captureAjaxErrorMessage(`report-black-type余额弹窗黑名单接口加载失败`, { error });
    });
  }

  // 获取余额捐赠数据
  fetchDonatePage(data: any) {
    return ajax({
      data,
      url: '/balance/transferOut',
    });
  }

  fetchGetOrderParams(data: any) {
    const url = '/balance/donateOrder';
    return ajax({
      data,
      url,
    });
  }

  fetchTransferCashierUrl(data: any) {
    const url = '/balance/cashierUrl';
    return ajax({
      data,
      url,
    });
  }

  fetchBillList(data: any) {
    const url = '/balance/detailList';
    return ajax({
      data,
      url,
      toastType: 'hide',
    });
  }

  // 获取提现列表
  fetchWithdrawList(data: any) {
    const url = '/balanceproduct/withdraw/detailList';
    return ajax({
      data,
      url,
      toastType: 'hide',
    });
  }

  // 获取历史退款至余额记录
  fetchHistoryRefundList(data: any) {
    const url = '/balance/detailListHistory';
    return ajax({
      data,
      url,
      toastType: 'hide',
    });
  }

  fetchBillDetail(data: IFetchBillDetailReq) {
    const url = '/balance/detail';
    return ajax({
      data,
      url,
      toastType: 'hide',
    });
  }

  fetchRewardAmount() {
    const url = '/balance/rewardAmount';
    return ajax({ url });
  }

  // 余额明细入口
  fetchLatestBalanceDetail() {
    const url = '/balance/latestDetail';
    return ajax({ url });
  }

  // 美团支付路由接口，通过该接口获取调转到美团支付的url
  goHelloPay(data: IGoHelloPayReq): Promise<IGoHelloPayRes> {
    const url = '/cashier/gohellopay';
    return ajax({
      data,
      url,
      noEncrypt: true,
    });
  }

  // 支付提交接口
  mtPay(
    data: IMTPayReq,
    successCallback: (res: any) => void,
    failCallback: (err: any) => void,
    showToast: boolean
  ): void {
    const url = '/cashier/mtpay';
    ajax({
      data,
      url,
      toastType: showToast ? 'show' : '',
      customErrorModal: {
        title: '充值失败',
        className: 'recharge-error-modal',
        closeButton: true,
      },
    })
      .then((res: any) => {
        if (res.status === 'success') {
          successCallback(res.data);
        } else {
          successCallback(res);
        }
      })
      .catch((err) => {
        failCallback(err);
      });
  }

  // 提现详情 & 提现结果 接口
  withdrawDetail(data: IWithdrawDetailReq): Promise<IWithdrawDetailRes> {
    const url = '/balanceproduct/withdraw/detail';
    return ajax({
      data,
      url,
      toastType: 'hide',
      customErrorHandle: true,
    });
  }

  // 充值结果查询接口
  rechargeDetail(data: IRechargeDetailReq): Promise<IRechargeDetailRes> {
    const url = '/balanceproduct/recharge/resultDetail';
    return ajax({
      data,
      url,
      toastType: 'hide',
      customErrorHandle: true,
    });
  }

  // 余额处理-放弃余额-获取验证方式
  getAvailableAuthentication(data: IAvailableAuthenticationReq): Promise<IAvailableAuthenticationRes> {
    const url = '/api/i/wallet/getAvailableAuthentication';
    return ajax({
      data,
      url,
      toastType: 'hide',
      customErrorHandle: true,
    });
  }

  //  余额处理-放弃余额-身份信息验证方式获取
  getThreeFactorCertificateUrl(data: IThreeFactorCertificateUrlReq): Promise<IThreeFactorCertificateUrlRes> {
    const url = '/api/i/wallet/getThreeFactorCertificateUrl';
    return ajax({
      data,
      url,
      toastType: 'hide',
      customErrorHandle: true,
    });
  }

  postFakeClosePayAccount(data: IFakeClosePayAccountReq): Promise<void> {
    const url = '/balance/markClosePayAccount';
    return ajax({
      data,
      url,
    });
  }
}

export const request = new Request();
